import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { sortBy } from 'lodash';
import formatMoney from 'utils/formatters/Money';

import { getDocuments, getSignedUrl } from 'utils/DocumentsAPIUtils';
import LineItem from './LineItem';

class ShipmentCharges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lineItemsForRender: [],
    };
  }
  static propTypes = {
    charges: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      shipment_id: PropTypes.string.isRequired,
      lineItems: PropTypes.arrayOf(
        PropTypes.shape({
          processed: PropTypes.bool.isRequired,
          value: PropTypes.number,
          message: PropTypes.string,
          type: PropTypes.string,
          category: PropTypes.string,
        }),
      ),
      selected: PropTypes.array.isRequired,
    }),
    chargeCountMap: PropTypes.object.isRequired,
    onToggleSelect: PropTypes.func.isRequired,
    onToggleSelectAll: PropTypes.func.isRequired,
    onGroupItem: PropTypes.func.isRequired,
  };

  static defaultProps = {
    charges: [],
  };

  openPOD = async (pod, windowRef) => {
    try {
      const { data: signedUrl } = await getSignedUrl(pod);

      windowRef.location = signedUrl?.getSignedUrl?.signedUrl;
    } catch (e) {
      console.error('job-history: error getting signed URL:', e);
    }
  };

  handlePODClick = (pod) => (event) => {
    // Need this hoky workaround for Safari.
    // It doesn't allow window.open in an async function.
    event.preventDefault();
    const windowRef = window.open();
    this.openPOD(pod, windowRef);
  };

  handleToggleSelect = (lineItem) => (e) => {
    const {
      target: { checked },
    } = e;

    const {
      charges: { _id },
    } = this.props;

    this.props.onToggleSelect(_id, lineItem._id, checked);
  };

  handleToggleSelectAll = (e) => {
    const {
      target: { checked },
    } = e;

    const {
      charges: { _id },
    } = this.props;

    this.props.onToggleSelectAll(_id, checked);
  };

  render() {
    const {
      charges: {
        lineItems,
        shipment_id,
        selectAllChecked,
        selectAllDisabled,
        total,
        _id,
        currency,
        selected,
      },
      chargeCountMap,
      onGroupItem,
      t,
    } = this.props;
    const lineItemsForRender = sortBy(lineItems, ['type', 'timestamp']);
    const hasLineItems = lineItems.length > 0;
    const link = `/shipments/${_id}`;
    return (
      <div className="mb-4 bg-white rounded shadow">
        <div className="flex content-center justify-between p-4 border-b border-solid border-grey-lighter">
          <div className="flex items-center">
            <input
              type="checkbox"
              className="leading-tight form-field"
              disabled={selectAllDisabled}
              checked={selectAllChecked}
              onChange={this.handleToggleSelectAll}
            />
            <a href={link} target="_blank" rel="noopener noreferrer">
              <h4 className="my-0 ml-4 text-xl text-black">{shipment_id}</h4>
            </a>
          </div>
          <span className="text-xl text-grey-darker">
            {formatMoney(total, currency)}
          </span>
        </div>
        <div className="p-4">
          {hasLineItems && (
            <div className="mb-2">
              {lineItemsForRender.map((lineItem) => {
                return (
                  <LineItem
                    shipmentId={_id}
                    selected={selected}
                    chargeCountMap={chargeCountMap}
                    lineItem={lineItem}
                    handlePODClick={this.handlePODClick}
                    handleToggleSelect={this.handleToggleSelect}
                    onGroupItem={onGroupItem}
                  />
                );
              })}
            </div>
          )}
          {!hasLineItems && <p>{t('NO_CHARGES_FOUND')}</p>}
        </div>
      </div>
    );
  }
}

export default withTranslation()(ShipmentCharges);
